<div class="content-wrapper container-xxl p-0">
  <div class="content-body" *ngIf="currentJobPosition">
    <div class="row">
      <div class="col-lg-8 col-12">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
      </div>
      <div class="col-lg-4 col-12 text-right">
        <button class="btn btn-outline-primary mb-1">
          <a href="dashboard/job-positions/edit/{{ currentJobPosition.slug }}">{{ "EDIT" | translate }}</a>
        </button>
      </div>
    </div>
    <section id="page-accordion">
      <div class="row">
        <div class="col-12">
          <!--Detail Section-->
          <div id="detail-section" class="card" [ngClass]="activeTab === 'detail' ? 'active' : ''">
            <div class="card-title px-2 mb-0" (click)="changeTab('detail')">
              <h4>{{ "DETAIL_SINGULAR" | translate }} {{ currentJobPosition.title }}</h4>
            </div>
            <section [ngClass]="activeTab === 'detail' ? 'card-body' : ''">
              <div class="row">
                <div class="col-lg-3 col-12 mb-1">
                  <div class="font-weight-bold">{{ "TITLE" | translate }}:</div>
                  <div>{{ currentJobPosition.title }}</div>
                </div>
                <div class="col-lg-3 col-12 mb-1">
                  <div class="font-weight-bold">{{ "FIGURE" | translate }}:</div>
                  <div>{{ currentJobPosition.figure_name }}</div>
                </div>
                <div class="col-lg-3 col-12 mb-1">
                  <div class="font-weight-bold">{{ "JOB_CATEGORY" | translate }}:</div>
                  <div>{{ currentJobPosition.category_name }}</div>
                </div>
                <div class="col-lg-3 col-12 mb-1">
                  <div class="font-weight-bold">{{ "CITY" | translate }}:</div>
                  <div>{{ currentJobPosition.city_name }}</div>
                </div>
                <div class="col-lg-3 col-12 mb-1">
                  <div class="font-weight-bold">{{ "MODE" | translate }}:</div>
                  <div>{{ currentJobPosition.site_name }}</div>
                </div>
                <div class="col-lg-3 col-12 mb-1">
                  <div class="font-weight-bold">{{ "REQUEST" | translate }}:</div>
                  <a href="dashboard/detail-request/{{ currentJobPosition.request_id }}" *ngIf="!!currentJobPosition.request_name">{{ currentJobPosition.request_name ? currentJobPosition.request_name : "-" }}</a>
                  <span *ngIf="!currentJobPosition.request_name">-</span>
                </div>
                <div class="col-12 mb-1">
                  <div class="font-weight-bold">{{ "SUMMARY" | translate }}:</div>
                  <div [innerHTML]="currentJobPosition.summary"></div>
                </div>
                <div class="col-12 mb-1">
                  <div class="font-weight-bold">{{ "DESCRIPTION" | translate }}:</div>
                  <div [innerHTML]="currentJobPosition.description"></div>
                </div>
              </div>
            </section>
          </div>
          <!--CANDIDATE-->
          <div id="candidature-section" class="card" [ngClass]="activeTab === 'candidateSection' ? 'active' : ''">
            <div class="card-title px-2 mb-0 d-flex align-items-center" (click)="changeTab('candidateSection')">
              <h4 class="mr-1 mb-0">{{ "CANDIDATURE" | translate }}</h4>
              <span>{{ activeTab === "candidateSection" ? "" : candidateList.length }}</span>
            </div>
            <section [ngClass]="activeTab === 'candidateSection' ? 'card-body px-0 pb-0' : ''">
              <div class="row">
                <div class="col-12">
                  <!-- desktop-->
                  <ngx-datatable
                    class="bootstrap core-bootstrap"
                    columnMode="force"
                    [headerHeight]="30"
                    [scrollbarH]="true"
                    [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
                    [rowHeight]="_utilService.isDesktop ? 80 : 190"
                    [limit]="10"
                    [footerHeight]="30"
                    [rows]="filteredCandidateList"
                  >
                    <ngx-datatable-column [name]="'FIRSTNAME' | translate" prop="firstname" [sortable]="true" *ngIf="_utilService.isDesktop">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <span>{{ row.firstname }}</span>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [name]="'LASTNAME' | translate" prop="lastname" [sortable]="true" *ngIf="_utilService.isDesktop">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <span>{{ row.lastname }}</span>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [name]="'PHONE' | translate" prop="phone" *ngIf="_utilService.isDesktop">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <span>{{ row.phone }}</span>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [name]="'EMAIL' | translate" prop="email" *ngIf="_utilService.isDesktop">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <span>{{ row.email }}</span>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <div class="d-flex">
                          <button
                            class="bg-transparent text-success border-0 pr-1"
                            *ngIf="_authenticationService.hasCapability('create_candidate')"
                            (click)="transformToCandidate(row)"
                            [ngbTooltip]="'TRANSFORM_TO_CANDIDATE' | translate"
                          >
                            <i [data-feather]="'user-plus'" size="19"></i>
                          </button>
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <!--mobile - tablet-->
                    <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true" *ngIf="!_utilService.isDesktop">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <div class="row list-item-mobile">
                          <div class="col-12 pl-0">
                            <span class="font-weight-bold">{{ "FIRSTNAME" | translate }}: </span>
                            <span>{{ row.firstname }}</span>
                          </div>
                          <div class="col-12 pl-0">
                            <span class="font-weight-bold">{{ "LASTNAME" | translate }}: </span>
                            <span>{{ row.lastname }}</span>
                          </div>
                          <div class="col-12 pl-0">
                            <span class="font-weight-bold">{{ "PHONE" | translate }}: </span>
                            <span>{{ row.phone }}</span>
                          </div>
                          <div class="col-12 pl-0">
                            <span class="font-weight-bold">{{ "EMAIL" | translate }}: </span>
                            <span>{{ row.email }}</span>
                          </div>
                          <div class="col-12 mt-075">
                            <div class="d-flex justify-content-end mr-1">
                              <button
                                class="bg-transparent text-success border-0"
                                *ngIf="_authenticationService.hasCapability('create_candidate')"
                                (click)="transformToCandidate(row)"
                                [ngbTooltip]="'TRANSFORM_TO_CANDIDATE' | translate"
                              >
                                <i [data-feather]="'user-plus'" size="19"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
